import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = ".SCFOj{height:100%;max-width:100%;position:relative;width:100%}.bGaXB{bottom:0;position:absolute;top:0}[dir] .bGaXB{background:rgba(51,51,51,.05)}[dir=ltr] .bGaXB{left:0;right:0}[dir=rtl] .bGaXB{left:0;right:0}";
var htmlComponentStyles = {"htmlComponent":"SCFOj","htmlComponent_placeholder":"bGaXB"};
styleInject(css_248z);

export { htmlComponentStyles as h };
//# sourceMappingURL=HtmlComponent-0b86bde9.js.map
